import React from 'react';

import type { FacebookGroupPostComponentsProps } from './types';

export function Footer(_props: FacebookGroupPostComponentsProps): React.JSX.Element {
	return <div>Facebook Group Post Footer</div>;
}
